
// Initialize all tickers by class instead of a single ID
$('.webTicker').each(function () {
  var $track = $(this);

  // Initialize plugin per ticker
  try { $track.webTicker('stop'); } catch (e) {}
  $track.webTicker({
    startEmpty: false,
    duplicate: true,
    // hoverpause: true,
    // direction: 'right'
  });

  // Skip height calculations and styling for header-cta text ticker
  var isHeaderTicker = $track.closest('.header-cta').length > 0;
  if (isHeaderTicker) {
    return; // Just initialize the scrolling, skip the height/card styling
  }

  var $container = $track.closest('.tickercontainer');

  function getMaxOuterHeight() {
    var maxH = 0;
    $track.children('li').each(function () {
      var el = this;
      var rectH = el.getBoundingClientRect().height; // includes padding+border
      var cs = window.getComputedStyle(el);
      var margin = parseFloat(cs.marginTop) + parseFloat(cs.marginBottom);
      var h = rectH + margin;
      if (h > maxH) maxH = h;
    });
    return Math.ceil(maxH);
  }

  function applyHeights() {
    var h = getMaxOuterHeight();
    if (!h) return;
    $container.css({ height: h, overflow: 'hidden' });
    $track.css({ height: h });
    $track.children('li').css({
      height: h,
      display: 'flex',
      alignItems: 'center',
      lineHeight: h + 'px'
    });
    // Make inner cards equal height as well
    $track.children('li').find('.card').css({
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box'
    });
  }

  // Recalc on load/resize/mutations for this ticker
  $(window).on('load', applyHeights);
  var t;
  $(window).on('resize', function () { clearTimeout(t); t = setTimeout(applyHeights, 150); });
  if ('MutationObserver' in window) {
    new MutationObserver(applyHeights).observe($track.get(0), { childList: true, subtree: true });
  }
  applyHeights();
});